import { render } from "./SelectedFilters.vue?vue&type=template&id=23a44bb8&scoped=true"
import script from "./SelectedFilters.vue?vue&type=script&lang=js"
export * from "./SelectedFilters.vue?vue&type=script&lang=js"

import "./SelectedFilters.vue?vue&type=style&index=0&id=23a44bb8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a44bb8"]])

export default __exports__